import React from "react";
import styled from "styled-components";


export default styled.div`
    float: left;
    margin: 0;
    padding: 0;
    width: 100%;
    list-style: none;
    // overflow: scroll;
    height: calc(100vh - 320px);
    background: white;
    overflow: hidden;
    padding: 35px 45px;
`;